import { render, staticRenderFns } from "./scantronManagement.vue?vue&type=template&id=6a6baf42"
import script from "./scantronManagement.vue?vue&type=script&lang=js"
export * from "./scantronManagement.vue?vue&type=script&lang=js"
import style0 from "./scantronManagement.vue?vue&type=style&index=0&id=6a6baf42&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports